import { render, staticRenderFns } from "./TbbHeader.vue?vue&type=template&id=9145711a&scoped=true"
import script from "./TbbHeader.vue?vue&type=script&lang=js"
export * from "./TbbHeader.vue?vue&type=script&lang=js"
import style0 from "./TbbHeader.vue?vue&type=style&index=0&id=9145711a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9145711a",
  null
  
)

export default component.exports